import { useState } from "react";
import useBreakpoint from "../../../../hooks/useBreakpoint";
import "./index.scss";

const CardSkeleton = ({ count = 6, aspectRatio = "portrait" }) => {
  const [size] = useBreakpoint();
  const isMobile = size === "xs" || size === "sm";

  const skeletonCards = Array(count).fill(null);

  return (
    <div className="card-skeleton-container">
      <div className="row">
        {skeletonCards.map((_, index) => (
          <div 
            key={`card-skeleton-${index}`} 
            className={`col-12 ${isMobile ? 'col-sm-12' : 'col-md-6 col-lg-4'} mb-4`}
          >
            <div className={`card-skeleton ${aspectRatio}`}>
              <div className="card-skeleton-image"></div>
              <div className="card-skeleton-body">
                <div className="card-skeleton-title"></div>
                <div className="card-skeleton-text"></div>
                <div className="card-skeleton-text"></div>
                <div className="card-skeleton-text card-skeleton-text-short"></div>
              </div>
              <div className="card-skeleton-footer">
                <div className="card-skeleton-button"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardSkeleton;